document.addEventListener('DOMContentLoaded', function() {
  // Get menu elements
  const menuButton = document.querySelector('.wxp-menu-button');
  const menuOverlay = document.querySelector('.wxp-menu-overlay');
  
  if (!menuButton || !menuOverlay) {
    console.error('Menu elements not found');
    return;
  }
  
  // Function to set up the nested menu structure
  function setupNestedMenu() {
    const menuItems = document.querySelectorAll('.wxp-menu-item');
    
    menuItems.forEach(item => {
      // Check if this menu item has child items
      const childMenu = item.querySelector('.wxp-submenu');
      const menuLink = item.querySelector('.wxp-menu-link');
      
      if (childMenu && childMenu.children.length > 0) {
        // Add has-children class to the link if not already present
        if (!menuLink.classList.contains('has-children')) {
          // Add has-children class to the link
          menuLink.classList.add('has-children');
          
          // Create and append arrow element if not already present
          if (!menuLink.querySelector('.wxp-menu-arrow')) {
            const arrow = document.createElement('span');
            arrow.className = 'wxp-menu-arrow';
            arrow.innerHTML = '›'; // Unicode right arrow
            menuLink.appendChild(arrow);
          }
          
          // Remove previous event listeners before adding new ones
          const newMenuLink = menuLink.cloneNode(true);
          menuLink.parentNode.replaceChild(newMenuLink, menuLink);
          
          // Add click event to toggle submenu
          newMenuLink.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Toggle submenu visibility
            childMenu.classList.toggle('active');
            newMenuLink.querySelector('.wxp-menu-arrow').classList.toggle('active');
            
            // Log submenu toggle
            console.log('Submenu toggled:', childMenu.classList.contains('active'));
          });
        }
      }
    });
    
    console.log('Nested menu setup complete');
  }
  
  // Toggle menu state when button is clicked
  menuButton.addEventListener('click', function(e) {
    e.preventDefault();
    
    console.log('Menu button clicked'); // Debug logging
    
    // Toggle active class on button and overlay
    menuButton.classList.toggle('active');
    menuOverlay.classList.toggle('active');
    
    // Setup nested menu structure when menu is opened
    if (menuOverlay.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
      // Allow a brief moment for any dynamic content to load
      setTimeout(setupNestedMenu, 50);
    } else {
      document.body.style.overflow = '';
    }
  });
  
  // Close menu when ESC key is pressed
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && menuOverlay.classList.contains('active')) {
      menuButton.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
  
  // Handle menu item hover effects
  const menuItems = document.querySelectorAll('.wxp-menu-item');
  
  // Optional: Additional hover effect handling if needed
  /*
  menuItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      // Additional hover effects if needed
    });
    
    item.addEventListener('mouseleave', function() {
      // Additional hover effects if needed
    });
  });
  */
  
  // Initialize nested menu on page load
  setupNestedMenu();
  
  console.log('Interactive menu initialized with parent-child support'); // Debug logging
});